import { FC } from 'react';
import { Card } from 'antd';
import * as React from 'react';

const ContractorClientFormBanner: FC<any> = ({}) => {
	const onSupportClick = () => window.Intercom && window.Intercom('show');
	return (
		<div className="flex" style={{ marginLeft: -8, marginBottom: 12 }}>
			<Card
				style={{ border: '1px solid #8ed7eb' }}
				bodyStyle={{
					padding: '8px 16px',
					background: '#ebfbff',
					marginLeft: -8,
				}}
			>
				<div>
					<div>
						<p
							style={{
								fontSize: 14,
								marginBottom: 0,
							}}
						>
							If your client already uses OpenWrench you do not need to add them and their locations
							here. Reach out to{' '}
							<span
								className={'font-medium text-blue-600 hover:underline dark:text-blue-500'}
								onClick={() => onSupportClick()}
							>
								OpenWrench Support
							</span>{' '}
							for help.
						</p>
					</div>
				</div>
			</Card>
		</div>
	);
};

export default ContractorClientFormBanner;
